import React, { useEffect, useState } from "react";
import RouteModal from "../../../../Component/BasicComponents/Modal/RouteModal";
import CustomInput from "../../../../Component/BasicComponents/CustomInput";
import ReusableDropdown from "../../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { Btn } from "../../../../AbstractElements";
// import { useGetOrgUnitsData } from "../../../Employee/hooks/useEmployee";
import { useAddTerritory, useGetPositionList,useUpdateTerritory} from "../UseTerriitory";
import { useGetOrgUnitsData } from "../../Beats_Patches/hooks/useBeat";

type ProductCardProps = {
  setIsModalOpen?: any;
  isModalOpen?: any;
  toggleModal?: any;
  title?: any;
  checkAddEditStatus?: any;
  setCheckAddEditStatus?: any;
  rowData?: any;
};

interface modalDataInteface{
   Name:string,
   orgUnitId:number | null,
   PositionId:string
   TerritoryId:any
}

const TerritoryAddAndEditModal: React.FC<ProductCardProps> = ({rowData,setIsModalOpen,isModalOpen,title,/*handleSubmit,*/checkAddEditStatus,setCheckAddEditStatus,}) => {
  const [selectOrgUnit, setSelectOrgUnit] = useState<any>([]);
  
  const [modalData, setModalData] = useState<modalDataInteface>({
    Name: checkAddEditStatus === "Edit" ? rowData?.Name : "",
    orgUnitId: checkAddEditStatus === "Edit" ? rowData?.Orgunitid : '',
    PositionId:checkAddEditStatus === "Edit" ? rowData?.PositionId : '',
    TerritoryId:checkAddEditStatus === "Edit" ? rowData?.id : '',

});

  useEffect(() => {
      if (checkAddEditStatus === "Edit" && rowData) {
          setModalData((prev:any)=>({
            ...prev,
            Name:rowData.Name,
            orgUnitId:rowData.Orgunitid,
            PositionId:rowData.PositionId,
            TerritoryId:rowData.id
          }))
        } else {
            setModalData((prev:any)=>({
                ...prev,
                Name:"",
                orgUnitId:null,
                PositionId:null,
                TerritoryId:0
            }));
        }
    }, [checkAddEditStatus, rowData,]);
  
const {mutate:AddTerritory} = useAddTerritory();
const {mutate: UpdateTerritory} = useUpdateTerritory();
const {data: orgUnitsData,isLoading: orgDataLoading,isSuccess: orgDataSuccess} = useGetOrgUnitsData({ enable: true });
const {data: PositionList, isLoading: PositionListLoading,isSuccess: PositionSuccess} = useGetPositionList({ enable: true, id: modalData.orgUnitId,TerritoryId:modalData.TerritoryId});

let dataForPositons;
if (PositionList && PositionSuccess) {
    dataForPositons = Object.entries(PositionList?.data).map( ([id, label]) => ({
    id:id,
    label: String(label),
  }));
}
 
  const handleInput = (key: string, value: any) => {
    setModalData((prev: any) => ({
      ...prev,
      [key]: value,
    }));
  };

const handleSubmit = (e:any)=>{
    e.preventDefault();
  if(checkAddEditStatus === "Add"){
     
    const body={
     TerritoryName: modalData.Name,
     Orgunitid: modalData.orgUnitId,    
     PositionId: Number(modalData.PositionId)
     }

   AddTerritory({ReqBody:body},)
  setIsModalOpen(false); 

  }

  if(checkAddEditStatus === 'Edit'){
  
    const body={
     TerritoryName: modalData.Name,
     Orgunitid: modalData.orgUnitId,    
     PositionId: Number(modalData.PositionId)
     }
   
     UpdateTerritory({ReqBody:body,TerritoryID:modalData.TerritoryId},{onSuccess:()=>{

       setIsModalOpen(false); 
     }});

  }

  // setIsModalOpen(false); 
 }

  return (
    <RouteModal
      isOpen={isModalOpen}
      toggle={() => {
        setIsModalOpen(!isModalOpen);
      }}
      title={title}
      size="sm"
      content={
        <form onSubmit={handleSubmit}>
          <div className="row mb-0">
            <CustomInput
              placeholder="Name"
              disabled={false}
              onChange={(e: any) => {
                handleInput("Name", e.target.value);
              }}
              value={modalData.Name}
              required={true}
              label="Name*"
              style={{
                border: "1px solid #EDEDED",
                borderRadius: "4px",
                padding: "10px",
                fontSize: "14px",
                backgroundColor: "#fff",
              }}
            />
            <ReusableDropdown
              options={(!orgDataLoading && orgDataSuccess && orgUnitsData?.data) || []}
              value={String(modalData.orgUnitId)}
              onChange={(value: any) => setModalData((prev:any)=>({
                ...prev,
                orgUnitId:value
              }))}
              DropdownHeading="Org Unit*"
            />
            <ReusableDropdown
              options={(!PositionListLoading && PositionSuccess && dataForPositons ) || []}
              // options={[{id: 640, label: 'HYDERABAD'}]}
              value={modalData.PositionId}
              onChange={(value: any) =>setModalData((prev:any)=>({
                ...prev,
                PositionId:value
              }))}

              // onChange={(value:any)=>console.log('value',typeof(value))}


              DropdownHeading="Position*"
            />

            <div style={{ height: 20 }} />
            <div className="d-flex justify-content-start gap-2">
              <Btn
                style={{ backgroundColor: "#43B9B2", color: "white" }}
                type="submit"
              >
                {checkAddEditStatus === "Add" ? "Submit" : "Update"}
              </Btn>
              <Btn
                style={{
                  backgroundColor: "#F9FAFC",
                  color: "#000",
                  border: "1px solid #E0E0E0",
                }}
                type="button"
                onClick={() => {
                  setIsModalOpen(false);
                  setCheckAddEditStatus("");
                }}
              >
                Cancel
              </Btn>
            </div>
          </div>
        </form>
      }
    />
  );
};

export default TerritoryAddAndEditModal;
